import { computed } from "vue"
import store from '@shared/store/index'; 

export const isLegendUser = computed(() => store.getters['UserSystem/hasLegendAccess']);